import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(radioAnatomy.keys);

export const Radio = defineMultiStyleConfig({
	baseStyle: {
		control: {
			bgColor: 'white',
			borderColor: 'gray.300',
			borderRadius: 'full',
			borderStyle: 'solid',
			borderWidth: '1px',
			boxSize: 5,
			cursor: 'pointer',
			_checked: {
				bgColor: 'white',
				_before: {
					bg: 'blue.500',
					borderRadius: 'full',
					content: '""',
					display: 'block',
					h: 3.5,
					w: 3.5,
				},
				_disabled: {
					_before: {
						bg: 'gray.300',
					},
				},
				_hover: {
					bgColor: 'white',
				},
			},
			_disabled: {
				bgColor: 'white',
				borderColor: 'gray.300',
			},
			_hover: {
				bgColor: 'white',
			},
		},
		label: {
			ml: 2,
			_groupDisabled: {
				color: 'gray.300',
			},
		},
		container: {},
	},
});
